import { Grid } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { TextInput } from "qubCommon/Inputs";
import ExplorerCard from "wrappers/ExplorerWrapper";
import useDashboardExplorerCriteria from "../useDashboardExplorerCriteria";

const DisbursementsExplorer = () => {
  const dashboardCriteria = useDashboardExplorerCriteria({
    typeCriteriaKey: "DisbursementType",
    statusCriteriaKey: "DisbursementStatus",
  });

  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: "Disbursements-Expl",
    hideAddNew: true,
    ...dashboardCriteria,
  });

  const { explParams, ...explorerRest } = useExplorerGrid({
    explorerDataKey: "Disbursements-Expl",
    xlsxName: "Disbursements",
    navUrl: "/disbursement-application/{:id}",
    status,
    ...dashboardCriteria,
  });

  return (
    <>
      <Can I="View" a="MHD_GovnrDisbursements">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          <ExplorerGrid
            explParams={explParams}
            title="Disbursements"
            breadcrumbs={[
              {
                name: "Disbursements",
                path: "govnr/disbursement-applications",
              },
            ]}
            hideAscendingRowNumber
            autoRowHeights
            {...explorerRest}
            {...toolbarRest}
          >
            <Grid item xs={12} md={6} lg={4}>
              <TextInput
                id="Search"
                name="searchFieldValue"
                label={"Αναζήτηση"}
                placeholder={"Αναζήτηση"}
                defaultValue={critParams?.searchFieldValue ?? ""}
              />
            </Grid>
          </ExplorerGrid>
        </div>
      </Can>
      <Can not I="View" a="MHD_GovnrDisbursements">
        <PageNotFound />
      </Can>
    </>
  );
};
export default DisbursementsExplorer;
